@if(!isNavButton) {
  <button class="loading-button"
          [ngClass]="buttonTheme"
          [type]="isFormSubmitButton ? 'submit' : 'button'"
          [disabled]="disabledCondition || loading"
          (click)="clickEvent.emit()"
  >
    @if (!loading && leadingImageUrl){
      <div class="img-container">
        <img src="{{leadingImageUrl}}" height="28"/>
      </div>
    }
    @if (!loading && leadingIcon) {
      <div class="material-icons">{{ leadingIcon }}</div>
    }
    @if (!loading) {
      <div>{{ text }}</div>
    }
    @if(loading){
      <div class="button-loading-spinner"></div>
    }
  </button>
} @else {
  <button class="navbutton"
          [ngClass]="buttonTheme"
          [type]="isFormSubmitButton ? 'submit' : 'button'"
          [disabled]="disabledCondition || loading"
          (click)="clickEvent.emit()"
  >
    @if (!loading && leadingImageUrl){
      <div class="img-container">
        <img src="{{leadingImageUrl}}" height="28"/>
      </div>
    }
    @if (!loading && leadingIcon) {
      <div class="material-icons">{{ leadingIcon }}</div>
    }
    @if (!loading) {
      <div>{{ text }}</div>
    }
    @if(loading){
      <div class="button-loading-spinner"></div>
    }
  </button>
}




